export default {
  SAVE_SUMMARY: (state, data) => {
    let summary = state.summary
    summary.calculations = data.summary.calculations
    summary.payments = data.summary.payments
    summary.pending = false
  },
  SAVE_SALDO: (state, data) => {
    state.summary.payments = data.summary.payments
  },
  PENDING: (state, data) => {
    state.summary.pending = data
  },
  SAVE_HISTORY: (state, data) => {
    state.history = data.history
    state.history.pending = false
  },
  PENDING_HISTORY: (state, data) => {
    state.history.pending = data
  },
  SAVE_TRANCHES: (state, data) => {
    state.tranches = data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/statistics/mutations.js